import { twMerge } from 'tailwind-merge';

interface CheckBoxProps {
  id?: string;
  register?: any;
  checked?: boolean;
  inputClassname?: string;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  multimode?: boolean;
  index?: number;
  defaultChecked?: boolean;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  id = 'checkbox',
  register,
  checked,
  inputClassname,
  disabled = false,
  onChange,
  multimode,
  index,
  defaultChecked = false,
}) => {
  const reg = multimode
    ? register(`giftMessage.${index}.add_greeting_card`)
    : register(id);
  return (
    <input
      type='checkbox'
      id={id}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      className={twMerge('accent-fig', inputClassname)}
      onClick={onChange}
      {...reg}
    />
  );
};

export default CheckBox;
